// src/components/Conception/index.jsx
import React, { useRef, useEffect, useState, memo } from "react";
import { Link } from "react-router-dom";
import BpmnModeler from "bpmn-js/lib/Modeler";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import GRAIEditorLite from "../GRAIEditorLite";
// PDF uploader dependencies
import "../PdfUploader/PdfUploader.css";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css";

import "./Conception.css";

const MemoGRAIEditorLite = memo(GRAIEditorLite);

export default function Conception() {
  const [activeEditor, setActiveEditor] = useState("activity");
  // SAVING: PDF uploader states
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState("");
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [caseId, setCaseId] = useState(null);
  const [caseData, setCaseData] = useState(null);

  const fileInputRef = useRef(null);

  

  // Refs
  const iframeRef = useRef(null);
  const bpmnContainerRef = useRef(null);
  const modelerRef = useRef(null);
  const excalidrawRef = useRef(null);
  const savingIframeRef = useRef(null);

  /* -----------------------------------------
      VISUAL PARADIGM
  ------------------------------------------*/
  const handleImport = () => alert("Import inside Visual Paradigm.");
  const handleExport = () => alert("Export inside Visual Paradigm.");
  const handleReset = () =>
    iframeRef.current && (iframeRef.current.src = iframeRef.current.src);

  /* -----------------------------------------
      BPMN INITIALISATION (UNE SEULE FOIS)
  ------------------------------------------*/
  useEffect(() => {
    if (!bpmnContainerRef.current) return;
    if (modelerRef.current) return; // â— empàªcher double initialisation

    modelerRef.current = new BpmnModeler({
      container: bpmnContainerRef.current,
    });

    const initialDiagram = `
      <?xml version="1.0" encoding="UTF-8"?>
      <bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
        xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"
        xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"
        xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"
        xmlns:di="http://www.omg.org/spec/DD/20100524/DI"
        targetNamespace="http://bpmn.io/schema/bpmn">
        <bpmn:process id="Process_1" isExecutable="false">
          <bpmn:startEvent id="StartEvent_1" />
        </bpmn:process>
        <bpmndi:BPMNDiagram id="BPMNDiagram_1">
          <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
            <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
              <dc:Bounds x="150" y="150" width="36" height="36"/>
            </bpmndi:BPMNShape>
          </bpmndi:BPMNPlane>
        </bpmndi:BPMNDiagram>
      </bpmn:definitions>
    `;

    modelerRef.current.importXML(initialDiagram).then(() => {
      modelerRef.current.get("canvas").zoom("fit-viewport");
    });
  }, []);

  /* -----------------------------------------
      BPMN EXPORTS
  ------------------------------------------*/
  const resetBPMN = async () => {
    if (!modelerRef.current) return;
    const { xml } = await modelerRef.current.saveXML({ format: true });
    await modelerRef.current.importXML(xml);
    modelerRef.current.get("canvas").zoom("fit-viewport");
  };

  const exportBPMN = async () => {
    const { xml } = await modelerRef.current.saveXML({ format: true });
    const blob = new Blob([xml], { type: "text/xml" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "diagram.bpmn";
    a.click();
    URL.revokeObjectURL(url);
  };

  const exportBPMNPDF = async () => {
    try {
      const element = document.querySelector(".bpmn-wrapper");
      const canvas = await html2canvas(element, {
        scale: 3,
        backgroundColor: "#ffffff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("landscape", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      let position = 0;
      while (position < pdfHeight) {
        pdf.addImage(imgData, "PNG", 0, -position, pdfWidth, pdfHeight);
        position += pdf.internal.pageSize.getHeight();
        if (position < pdfHeight) pdf.addPage();
      }

      pdf.save("bpmn-diagram.pdf");
    } catch (error) {
      alert("PDF export error.");
    }
  };

  /* -----------------------------------------
      SAVING - PDF UPLOADER LOGIC
------------------------------------------*/

// Load caseId
useEffect(() => {
  const storedCaseId = localStorage.getItem("caseId");
  if (storedCaseId && storedCaseId !== "undefined" && storedCaseId !== "null") {
    setCaseId(storedCaseId);
  } else {
    setError("No active case found.");
  }
}, []);

// Load case details
useEffect(() => {
  if (!caseId) return;
  const apiUrl = process.env.REACT_APP_API_URL;

  if (!apiUrl) {
    setError("API_URL not defined");
    return;
  }

  fetch(`${apiUrl}/api/case-details/${caseId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
  })
    .then((res) => res.json())
    .then((data) => setCaseData(data.case))
    .catch(() => setError("âŒ Cannot load case details"));
}, [caseId]);

  // Choose PDF
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      setError("Please select a real PDF file.");
      setPdfFile(null);
      setPdfUrl(null);
      return;
    }

    setError("");
    setPdfFile(file);
    setPdfUrl(URL.createObjectURL(file));
  };

// Remove PDF
  const handleRemoveFile = () => {
    setPdfFile(null);
    setPdfUrl(null);
    setMessage("");
    setError("");

    if (fileInputRef.current) fileInputRef.current.value = null;
  };

// Upload PDF
  const handleUpload = async () => {
    if (!pdfFile) return setError("No file selected!");
    if (!caseId) return setError("Missing case ID!");

    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) return setError("API_URL not defined");

    setUploading(true);
    setMessage("Uploading...");
    setError("");

    try {
      const formData = new FormData();
      formData.append("file", pdfFile);

      const response = await fetch(`${apiUrl}/api/case/${caseId}/upload-pdf`, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
      });

      if (!response.ok) throw new Error("Upload failed");

      setMessage("âœ… PDF successfully uploaded!");
    } catch (err) {
      setError("Upload failed!");
    } finally {
      setUploading(false);
    }
  };

  /* -----------------------------------------
      RETURN JSX
  ------------------------------------------*/
  return (
    <>
      <div className="conception-card">
        <h2 className="conception-title">Conception Models Hub</h2>
        <p className="conception-subtitle">
          Centralized workspace to design and export all project models.
        </p>
      </div>

      {/* TABS */}
      <div className="editor-tabs">
        <button onClick={() => setActiveEditor("activity")}>Functional view</button>
        <button onClick={() => setActiveEditor("bpmn")}>Process view</button>
        <button onClick={() => setActiveEditor("activity2")}>Physical model</button>
        <button onClick={() => setActiveEditor("class")}>Informational model</button>
        <button onClick={() => setActiveEditor("decisional")}>Decisional model</button>
        <button onClick={() => setActiveEditor("excalidraw")}>Management</button>
        <button onClick={() => setActiveEditor("saving")}>Saving</button>
      </div>

      {/* ACTIVITY */}
      <div
        style={{ display: activeEditor === "activity" ? "block" : "none" }}
        className="vp-container-conception"
      >
        <div className="vp-toolbar">
          <button onClick={handleImport}> Import</button>
          <button onClick={handleExport}>Export</button>
          <button onClick={handleReset}>Reset</button>
        </div>

        <h2 className="bpmn-title">Activity Diagram - Functionalview</h2>

        <iframe
          ref={iframeRef}
          className="vp-editor-frame"
          src="https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram"
          allowFullScreen
        ></iframe>
      </div>

      <div
        style={{ display: activeEditor === "activity2" ? "block" : "none" }}
        className="vp-container-conception"
      >
        <div className="vp-toolbar">
          <button onClick={handleImport}> Import</button>
          <button onClick={handleExport}>Export</button>
          <button onClick={handleReset}>Reset</button>
        </div>

        <h2 className="bpmn-title">Activity Diagram - PhysicalModel</h2>

        <iframe
          ref={iframeRef}
          className="vp-editor-frame"
          src="https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ActivityDiagram"
          allowFullScreen
        ></iframe>
      </div>

      {/* BPMN */}
      <div
        style={{
          visibility: activeEditor === "bpmn" ? "visible" : "hidden",
          position: activeEditor === "bpmn" ? "relative" : "absolute",
          pointerEvents: activeEditor === "bpmn" ? "auto" : "none",
          width: "100%",
        }}
      >
        <div className="bpmn-wrapper">
          <h2 className="bpmn-title">BPMN.IO - Process View</h2>
          <div ref={bpmnContainerRef} className="bpmn-container"></div>
        </div>

        <div className="toolbar">
          <button onClick={resetBPMN}>Reset</button>
          <button onClick={exportBPMN}>Export BPMN</button>
          <button onClick={exportBPMNPDF}>Export PDF</button>
        </div>
      </div>

      {/* CLASS */}
      <div
        style={{ display: activeEditor === "class" ? "block" : "none" }}
        className="vp-container-conception"
      >
        <div className="vp-toolbar">
          <button onClick={handleImport}>Import</button>
          <button onClick={handleExport}>Export</button>
          <button onClick={handleReset}>Reset</button>
        </div>

        <h2 className="bpmn-title">Class Diagram - Informational Model</h2>

        <iframe
          className="vp-editor-frame"
          src="https://online.visual-paradigm.com/app/diagrams/#diagram:proj=0&type=ClassDiagram"
          allowFullScreen
        ></iframe>
      </div>

      

      {/* GRAI */}
      <div
        style={{ display: activeEditor === "decisional" ? "block" : "none", padding: "20px" }}
      >
        <h2 className="bpmn-title">GRAI Lite - Decisional Model</h2>

        <div className="grai-lite-wrapper">
          <MemoGRAIEditorLite
            instanceId="grai_lite_conception"
            storageKey="graiLite_conception"
            title="Decisional Model - GRAI (Lite)"
          />
        </div>
      </div>

      {/* EXCALIDRAW */}
      <div
        style={{ display: activeEditor === "excalidraw" ? "block" : "none" }}
        className="vp-container-conception"
      >
        <div className="vp-toolbar">
          <button onClick={() => alert(" Import inside Excalidraw")}>
             Import
          </button>
          <button onClick={() => alert("Export inside Excalidraw")}>
            Export
          </button>
          <button
            onClick={() => {
              if (excalidrawRef.current) {
                excalidrawRef.current.src = excalidrawRef.current.src;
              }
            }}
          >
            Reset
          </button>
        </div>

        <h2 className="bpmn-title">
          Excalidraw - VSM / 5S / SMED / Kaizen / Visual Management
        </h2>

        <iframe
          ref={excalidrawRef}
          className="vp-editor-frame"
          src="https://excalidraw.com/?theme=light&embed=1"
          allowFullScreen
        ></iframe>
      </div>

      {/* SAVING */}
      <div
        className="saving-section"
        style={{ display: activeEditor === "saving" ? "block" : "none" }}
      >
        <div className="pdf-uploader-container">
          <div className="pdf-uploader-card">
            <h2 className="pdf-uploader-title">Upload Case PDF</h2>

            {/* Case info */}
            {caseData ? (
              <div className="analysis-header-card">
                <h3 className="analysis-company-name">
                  {caseData.company_name || caseData.enterpriseName}
                </h3>

                <p className="analysis-info-line">
                  <strong>Sector:</strong> {caseData.activity_sector}
                  <span style={{ margin: "0 6px" }}></span>
                  <strong>Size:</strong> {caseData.company_size} employees
                </p>

                <p className="analysis-info-line">
                  <strong>Created:</strong>{" "}
                  {new Date(caseData.timestamp).toLocaleString()}
                </p>
              </div>
            ) : (
              <p style={{ fontWeight: "bold" }}>Loading...</p>
            )}

            {/* PDF selection */}
            <label className="pdf-button upload">
              Select PDF
              <input
                ref={fileInputRef}
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </label>

            {error && <p style={{ color: "red" }}>{error}</p>}

            {pdfFile && (
              <>
                <p style={{ marginTop: "15px" }}>
                  <strong>{pdfFile.name}</strong>
                </p>

                <div className="pdf-buttons">
                  <button
                    className="pdf-button upload"
                    onClick={handleUpload}
                    disabled={uploading}
                  >
                    {uploading ? "Uploading..." : "Upload"}
                  </button>

                  <button className="pdf-button delete" onClick={handleRemoveFile}>
                    Remove
                  </button>
                </div>
              </>
            )}

            {message && (
              <p style={{ marginTop: "15px", color: "green", fontWeight: 500 }}>
                {message}
              </p>
            )}

            {pdfUrl && (
              <iframe src={pdfUrl} className="pdf-preview" title="PDF Preview" />
            )}
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="icam-navigation">
        <Link to="/analysisbeta">
          <button className="icam-nav-btn">Back to Analysis page</button>
        </Link>

        <Link to="/implementation">
          <button className="icam-nav-btn">Move to Evaluation</button>
        </Link>
      </div>
    </>
  );
}
